var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDobIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 52,
    viewBox: "0 0 53 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.2,
    x: 0.787109,
    y: 0.410156,
    width: 51.291,
    height: 51.291,
    rx: 4,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.4121 9.44629C28.0788 9.77962 29.4121 11.9796 29.4121 13.4463C29.4121 14.913 28.5188 15.4463 27.4121 15.4463C26.3054 15.4463 25.4121 15.2463 25.4121 13.7796C25.4121 12.313 26.7454 11.4463 27.4121 9.44629ZM36.7454 20.7796C40.0788 20.7796 42.7454 23.4463 42.7454 26.7796C42.7454 28.8596 41.6921 30.6863 40.0788 31.7663V39.4463H16.0788V31.7663C14.4654 30.6863 13.4121 28.8596 13.4121 26.7796C13.4121 23.4463 16.0788 20.7796 19.4121 20.7796H25.4121V16.7796H29.4121V20.7796H36.7454ZM28.0788 30.113C28.9628 30.113 29.8107 29.7618 30.4358 29.1366C31.0609 28.5115 31.4121 27.6637 31.4121 26.7796H33.4121C33.4121 27.6637 33.7633 28.5115 34.3884 29.1366C35.0135 29.7618 35.8614 30.113 36.7454 30.113C37.6295 30.113 38.4773 29.7618 39.1025 29.1366C39.7276 28.5115 40.0788 27.6637 40.0788 26.7796C40.0788 25.8956 39.7276 25.0477 39.1025 24.4226C38.4773 23.7975 37.6295 23.4463 36.7454 23.4463H19.4121C18.5281 23.4463 17.6802 23.7975 17.0551 24.4226C16.43 25.0477 16.0788 25.8956 16.0788 26.7796C16.0788 27.6637 16.43 28.5115 17.0551 29.1366C17.6802 29.7618 18.5281 30.113 19.4121 30.113C20.2962 30.113 21.144 29.7618 21.7691 29.1366C22.3943 28.5115 22.7454 27.6637 22.7454 26.7796H24.7454C24.7454 27.6637 25.0966 28.5115 25.7218 29.1366C26.3469 29.7618 27.1947 30.113 28.0788 30.113Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDobIcon);
export default __webpack_public_path__ + "static/media/dobIcon.5f2c322e39ee63b2855dceed722cb7a7.svg";
export { ForwardRef as ReactComponent };